import { all, takeEvery, put, call } from 'redux-saga/effects'
import { get, post, getAdminViaData, getViaStudies } from 'services/admin'
import actions from './actions'
import envVariables from '../../envVariables'
import { notification } from 'antd';

const DELETE_URL = '/admin/delete'
const RESET_ORG_ID_URL = '/admin/resetorgid'
const GET_USERS_BY_STUDY_URL = '/admin/usersbystudy'
const DELETE_USERS_BY_ID_URL = '/admin/delete/byid'
const GET_ADMIN_VIA_DATA_URL = envVariables.dataExportURL
const GET_SNAPSHOT_DATA_URL = envVariables.snapshotDataExportURL

export function* DELETE_GET() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const success = yield call(get, DELETE_URL)

  if (success) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        users: success,
      },
    })
  }

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* RESET_ORG_ID({ ...data }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })

  const success = yield call(post, RESET_ORG_ID_URL, data.payload)

  if (success) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        successResult: true,
      },
    })
  }

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* DELETE_POST({ ...data }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })

  const success = yield call(
    post,
    DELETE_URL,
    data.payload,
    "The selected user was deleted successfully.",
    'Failed to delete user.',
  )

  if (success) {
    yield put({
      type: actions.DELETE_USER,
      payload: {
        email: data.payload.email,
      },
    })
  }

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* GET_USERS_BY_STUDY(data) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })

  // Extract studyId and product from the parameters string (e.g. ?studyId=foo&product=bar)
  const params = new URLSearchParams(data.payload.parameters)
  const studyId = params.get('studyId')
  const product = params.get('product')

  // Check if study exists for Aura
  if (product === 'aura' && studyId) {
    const studyCheck = yield call(getViaStudies, { study_id: studyId, pageSize: 1 })
    if (!studyCheck || !studyCheck.items || studyCheck.items.length === 0) {
      notification.error({ message: `Study '${studyId}' does not exist.` })
      yield put({
        type: actions.SET_STATE,
        payload: {
          loading: false,
        },
      })
      return
    }
  }

  const result = yield call(get, GET_USERS_BY_STUDY_URL + data.payload.parameters, data.payload)

  if (result) {
    const usersArray = Array.isArray(result) ? result : (Object.values(result)[0] || [])
    if (usersArray.length === 0) {
      notification.warning({ message: 'No one has joined this study yet.' })
    }

    yield put({
      type: actions.SET_USERS_BY_STUDY,
      payload: {
        users: result,
      },
    })
  }

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* DELETE_USERS_BY_ID({ ...data }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })

  const result = yield call(
    post, 
    DELETE_USERS_BY_ID_URL, 
    data.payload,
    'The selected user(s) were successfully removed from the study.',
    'Failed to remove user(s).'
  )

  if (result) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        successResult: true,
      },
    })
  }

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* GET_ADMIN_VIA_DATA({ ...data }) {
  yield put({
    type: actions.SET_STATE,
    payload: { loading: true },
  })

  const product = data.payload?.products || data.payload?.product;
  const url = product === 'snapshot' ? GET_SNAPSHOT_DATA_URL : GET_ADMIN_VIA_DATA_URL;

  const result = yield call(getAdminViaData, url, { ...data })

  console.log('Saga received result:', result, 'Product:', product);

  if (result) {
    if (Array.isArray(result)) {
      let formattedData = result;
      
      if (product === 'snapshot') {
        formattedData = result.map((url) => {
          const urlParts = url.split('/');
          const fileName = urlParts[urlParts.length - 1].split('?')[0];
          
          let uploadDateTime = null;
          const fileNameWithoutExt = fileName.replace('.csv', '');
          const parts = fileNameWithoutExt.split('_');
          
          if (parts.length >= 5) {
            const timestampStr = parts[parts.length - 1];
            if (timestampStr && timestampStr.length === 14) {
              const year = timestampStr.substring(0, 4);
              const month = timestampStr.substring(4, 6);
              const day = timestampStr.substring(6, 8);
              const hour = timestampStr.substring(8, 10);
              const minute = timestampStr.substring(10, 12);
              const second = timestampStr.substring(12, 14);
              
              const utcDate = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);
              uploadDateTime = utcDate.toISOString();
            }
          }
          
          return {
            downloadUrl: url,
            fileName: fileName,
            product: 'snapshot',
            dataType: '',
            size: 0,
            uploadDateTime: uploadDateTime,
            fullPath: url
          };
        });
      }
      
      console.log('Formatted data:', formattedData);
      
      yield put({
        type: actions.SET_ADMIN_VIA_DATA,
        payload: { adminTestData: formattedData },
      })
    } else if (result.error || (result.success === false && result.error)) {
      const errorMessage = result.error || 'Unknown error occurred';
      notification.error({
        message: 'Data Export Failed',
        description: errorMessage
      });
      yield put({
        type: actions.SET_ADMIN_VIA_DATA,
        payload: { adminTestData: [] },
      })
    } else {
      console.warn('Unexpected result format:', result);
      yield put({
        type: actions.SET_ADMIN_VIA_DATA,
        payload: { adminTestData: [] },
      })
    }
  } else {
    console.warn('No result received');
    yield put({
      type: actions.SET_ADMIN_VIA_DATA,
      payload: { adminTestData: [] },
    })
  }

  yield put({
    type: actions.SET_STATE,
    payload: { loading: false },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DELETE_GET, DELETE_GET),
    takeEvery(actions.DELETE_POST, DELETE_POST),
    takeEvery(actions.RESET_ORG_ID, RESET_ORG_ID),
    takeEvery(actions.GET_USERS_BY_STUDY, GET_USERS_BY_STUDY),
    takeEvery(actions.DELETE_USERS_BY_ID, DELETE_USERS_BY_ID),
    takeEvery(actions.GET_ADMIN_VIA_DATA, GET_ADMIN_VIA_DATA),
  ])
}
